import { Divider } from "@mantine/core";

import classes from "./FormDivider.module.css";

/**
 * The dashed rule between a form's import row and its fields (design-system.md 3.6), with a small
 * muted label in the middle: "or enter manually", "saved brand data".
 */
export function FormDivider({ label }: { label: string }) {
  return (
    <Divider
      variant="dashed"
      labelPosition="center"
      label={<span className={classes.label}>{label}</span>}
      classNames={{ root: classes.divider }}
    />
  );
}
